import { render, staticRenderFns } from "./ChipCardFilter.vue?vue&type=template&id=127f80c0&"
import script from "./ChipCardFilter.vue?vue&type=script&lang=js&"
export * from "./ChipCardFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports